import React, { useEffect, useRef } from "react";
import { Button } from "../ui";
import MessageBubble from "./MessageBubble";
import { dayLabel } from "./threadFormat";

export default function MessageList({
  messages,
  onLoadOlder,
  hasOlder,
  onRetry,
  viewer,
}) {
  const bottomRef = useRef(null);
  const lastId = messages[messages.length - 1]?._id;
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ block: "end" });
  }, [lastId]);

  let lastDay = null;
  return (
    <div
      data-slot="thread-list"
      className="tw-grid tw-grid-cols-1 tw-min-h-0 tw-flex-1 tw-content-start tw-gap-4 tw-overflow-y-auto tw-py-2"
      role="log"
      aria-live="polite"
    >
      {hasOlder && (
        <Button
          variant="text"
          size="sm"
          className="tw-justify-self-start"
          onClick={onLoadOlder}
          data-slot="thread-load-older"
        >
          Load earlier messages
        </Button>
      )}
      {messages.map((m) => {
        const day = dayLabel(m.createdAt);
        const divider =
          day !== lastDay ? (
            <div
              data-slot="thread-day"
              className="tw-flex tw-items-center tw-gap-3 tw-text-xs tw-font-bold tw-text-text-muted"
              key={`day-${m._id}`}
            >
              <span aria-hidden="true" className="tw-h-px tw-flex-1 tw-bg-divider" />
              {day}
              <span aria-hidden="true" className="tw-h-px tw-flex-1 tw-bg-divider" />
            </div>
          ) : null;
        lastDay = day;
        return (
          <React.Fragment key={m.tempId || m._id}>
            {divider}
            <MessageBubble message={m} onRetry={onRetry} viewer={viewer} />
          </React.Fragment>
        );
      })}
      <div ref={bottomRef} />
    </div>
  );
}
